// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2k6P1","label":"LabeledBox_label__EW-Rm"};